import {
	Box,
	Button,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
} from "@mui/material";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import React from "react";
import { sizes } from "../approvalUtils";
import { views } from "./cgpgUtils";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerGroups, getProductGroups, setState } from "./cgpgSlice";

const selectWidth = sizes.w200;
const selectHeight = sizes.h35;

export default function Form() {
	const dispatch = useDispatch();
	const states = useSelector((store) => store.cgpgApproval);
	const {
		selectedView,
		groupStatusList,
		selectedGroupStatus,
		periods,
		selectedPeriod,
		countries,
		selectedCountry,
		selectedCountryID,
	} = states;

	const values = ["Value1", "Value2", "Value3"];
	const value = "Value";
	function setValue() {}

	function setView(event) {
		const view = event.target.value;
		dispatch(setState("selectedView", view));
	}

	function setGroupStatus(event) {
		const status = event.target.value;
		dispatch(setState("selectedGroupStatus", status));
	}

	function setCountry(event) {
		const name = event.target.value;
		let id = 0;
		if (name !== "All") {
			id = countries.find(
				(country) => country.countryName === name
			).countryID;
		}
		dispatch(setState("selectedCountry", name));
		dispatch(setState("selectedCountryID", id));
	}

	function setPeriod(event) {
		const period = event.target.value;
		dispatch(setState("selectedPeriod", period));
	}

	function search() {
      dispatch(setState("productGroupsTable", null));
      dispatch(setState("customerGroupsTable", null));
      dispatch(setState("customerGroups", null));
      dispatch(setState("customerGroups", null));
      dispatch(setState("selectedRows", []));

		const obj = {
			logedUser: JSON.parse(localStorage.getItem("data")),
			countryId: selectedCountryID,
			groupStatus: selectedGroupStatus,
			period: selectedPeriod,
			searchText: "",
		};

		if (selectedView === "Product Group") {
			dispatch(getProductGroups(obj));
		} else {
			dispatch(getCustomerGroups(obj));
		}
	}

	return (
		<Box sx={{ mt: 2 }}>
			<Grid container columnGap={2} rowGap={2}>
				<Grid item>
					<FormControl>
						<InputLabel>View By</InputLabel>
						<Select
							value={selectedView}
							label="ViewBy"
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setView}
						>
							{views.map((view, index) => {
								return (
									<MenuItem key={index} value={view.value}>
										{view.value}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item>
					<FormControl>
						<InputLabel>Group Status</InputLabel>
						<Select
							value={selectedGroupStatus}
							label="Group Status"
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setGroupStatus}
						>
							{groupStatusList.map((status, index) => {
								return (
									<MenuItem key={index} value={status.value}>
										{status.value}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item>
					<FormControl>
						<InputLabel>Country</InputLabel>
						<Select
							value={selectedCountry}
							label="Country"
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setCountry}
						>
							<MenuItem value={"All"}>{"All"}</MenuItem>
							{countries.map((country, index) => {
								return (
									<MenuItem key={index} value={country.countryName}>
										{country.countryName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item>
					<FormControl>
						<InputLabel>Period</InputLabel>
						<Select
							value={selectedPeriod}
							label="Period"
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setPeriod}
						>
							{periods.map((period, index) => {
								return (
									<MenuItem key={index} value={period.value}>
										{period.value}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item>
					<Button
						startIcon={<ManageSearchIcon />}
						sx={{
							bgcolor: "blue.main",
							color: "white.main",
							textTransform: "none",
							fontWeight: "bold",
							mt: 1,
							"&:hover": {
								bgcolor: "skyBlue.main",
								color: "black.main",
							},
						}}
						onClick={search}
					>
						Search
					</Button>
				</Grid>
			</Grid>
		</Box>
	);
}
